module.exports = __webpack_public_path__ + "img/affiliate-statistic.25647a58.svg";